import { PAYMENT_STATUS } from '../../../utils/constants';
import {
  acceptClientPayment,
  createClientPayment,
  createPaymentsClient,
  deleteClientPayment,
  editPaymentPlanForClient,
  getClientPayment,
  rejectPaymentForClient,
} from './asyncThunks';

export const createPaymentsForClientBuilder = builder => {
  builder.addCase(createPaymentsClient.pending, state => {
    state.createPaymentsClientPending = true;
  });
  builder.addCase(createPaymentsClient.fulfilled, (state, { payload }) => {
    const { data, paidInstallments, totalPaidAmount, totalAmountVendor, remainingAmount } = payload;
    state.clientPayments.notPaidInstallments = data;

    state.clientPayments.data = [...state.clientPayments.data, { ...paidInstallments }];
    state.clientPayments.totalPaidAmount = totalPaidAmount;
    state.clientPayments.totalAmountVendor = totalAmountVendor;
    state.clientPayments.remainingAmount = remainingAmount;

    state.createPaymentsClientPending = false;
  });
  builder.addCase(createPaymentsClient.rejected, state => {
    state.createPaymentsClientPending = false;
  });
};

export const getClientPaymentBuilder = builder => {
  builder.addCase(getClientPayment.pending, state => {
    state.getClientPaymentPending = true;
  });
  builder.addCase(getClientPayment.fulfilled, (state, { payload }) => {
    const { data, notPaidInstallments, totalPaidAmount, totalAmountVendor, remainingAmount } = payload;

    state.clientPayments.data = data;
    state.clientPayments.totalPaidAmount = totalPaidAmount;
    state.clientPayments.totalAmountVendor = totalAmountVendor;
    state.clientPayments.remainingAmount = remainingAmount;

    state.clientPayments.notPaidInstallments = notPaidInstallments;

    state.getClientPaymentPending = false;
  });
  builder.addCase(getClientPayment.rejected, state => {
    state.getClientPaymentPending = false;
  });
};

export const acceptClientRequestBuilder = builder => {
  builder.addCase(acceptClientPayment.pending, state => {
    state.acceptClientRequestPaymentPending = true;
  });
  builder.addCase(acceptClientPayment.fulfilled, (state, { payload }) => {
    const { paymentId } = payload;

    state.clientPayments.data = state.clientPayments.data.map(payment => {
      if (payment.id === paymentId) {
        payment.status = PAYMENT_STATUS.APPROVED;
      }
      return payment;
    });

    //state.clientPayments.notPaidInstallments = state.clientPayments.notPaidInstallments.splice(0, 1);

    state.acceptClientRequestPaymentPending = false;
  });
  builder.addCase(acceptClientPayment.rejected, state => {
    state.acceptClientRequestPaymentPending = false;
  });
};

export const rejectPaymentForClientBuilder = builder => {
  builder.addCase(rejectPaymentForClient.pending, state => {
    state.rejectClientRequestPaymentPending = true;
  });
  builder.addCase(rejectPaymentForClient.fulfilled, (state, { payload }) => {
    const { paymentId } = payload;

    state.clientPayments.data = state.clientPayments.data.map(payment => {
      if (payment.id === paymentId) {
        payment.status = PAYMENT_STATUS.REJECTED;
      }
      return payment;
    });

    state.rejectClientRequestPaymentPending = false;
  });
  builder.addCase(rejectPaymentForClient.rejected, state => {
    state.rejectClientRequestPaymentPending = false;
  });
};

export const createClientPaymentBuilder = builder => {
  builder.addCase(createClientPayment.pending, state => {
    state.createClientPaymentPending = true;
  });
  builder.addCase(createClientPayment.fulfilled, (state, { payload }) => {
    const { data } = payload;
    // state.clientPayments.data = [data, ...state.clientPayments.data];

    // state.clientPayments.notPaidInstallments = state.clientPayments.notPaidInstallments.splice(0, 1);
    state.createClientPaymentPending = false;
  });
  builder.addCase(createClientPayment.rejected, state => {
    state.createClientPaymentPending = false;
  });
};

export const editPaymentPlanForClientBuilder = builder => {
  builder.addCase(editPaymentPlanForClient.pending, state => {
    state.editPaymentPlanForClientPending = true;
  });
  builder.addCase(editPaymentPlanForClient.fulfilled, (state, { payload }) => {
    const { data, notPaidInstallments, totalPaidAmount, totalAmountVendor, remainingAmount } = payload;
    state.clientPayments.notPaidInstallments = notPaidInstallments;

    state.clientPayments.data = data;
    state.clientPayments.totalPaidAmount = totalPaidAmount;
    state.clientPayments.totalAmountVendor = totalAmountVendor;
    state.clientPayments.remainingAmount = remainingAmount;

    state.editPaymentPlanForClientPending = false;
  });
  builder.addCase(editPaymentPlanForClient.rejected, state => {
    state.editPaymentPlanForClientPending = false;
  });
};

export const deleteClientPaymentBuilder = builder => {
  builder.addCase(deleteClientPayment.pending, state => {
    state.deleteClientPaymentPending = true;
  });
  builder.addCase(deleteClientPayment.fulfilled, (state, { payload }) => {
    const { data } = payload;
    // state.clientPayments.notPaidInstallments = notPaidInstallments;

    // state.clientPayments.data = data;
    // state.clientPayments.totalPaidAmount = totalPaidAmount;
    // state.clientPayments.totalAmountVendor = totalAmountVendor;
    // state.clientPayments.remainingAmount = remainingAmount;

    state.deleteClientPaymentPending = false;
  });
  builder.addCase(deleteClientPayment.rejected, state => {
    state.deleteClientPaymentPending = false;
  });
};
